import { data } from '../../svg/Skip/data';
import { makeIcon } from '../makeIcon';

export const Skip = makeIcon(data, 'skip', 'Skip');

export default Skip;
